// Define global for libs that expect Node's global
if (typeof (window as any).global === 'undefined') {
  (window as any).global = window as any;
}

// Optional: polyfill setImmediate used by fbjs
// pnpm add setimmediate
import 'setimmediate';
